import React from 'react'
import { Link } from "react-router-dom";
import SliderHomeBanner from '../../component/slidercomponent/SliderHomeBanner';
import SliderOurClients from '../../component/SliderOurClients';


const HomeBanner = () => {
    return (
        <>

            <div style={{ overflow: "hidden" }}>
                {/* <section className="section-hero">
                    <div className="hero-area hero-area-1">
                        <div className="container-fluid space-x-128">
                            <div className="row">
                                <div className="col-sm-9 col-md-8 col-lg-7 col-xl-6 col-xxl-4">
                                    <div className="section-content-block">
                                        <span className="section-tag is-white-transparent"> Welcome to Rahul Logistics Katni</span>
                                        <h2 className="section-title hero-title text-light">
                                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                                Your Trusted Logistics Partner
                                               
                                            </div>
                                        </h2>
                                        <p className="section-text text-light mb-5">If you are looking for an impeccable Transportation service in India, you can contact us. We welcome your call & queries. Quick resolution is promised by expert executives</p>
                                        <a href="contact.html" className="btn btn-secondary-alt">
                                            Get In Touch
                                            <div className="btn-icon">
                                                <span>
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                                <span>
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="hero-area-linear-gradient-1" />
                        <img src="assets/images/hero-bg-img-1.jpg" alt="hero-bg-img-1" width={1920} height={898} className="img-cover hero-bg-1" />
                        <img src="assets/images/hero-th-1-element-1.png" alt="hero-th-1-element-1" width={621} height={741} className="img-fluid hero-th-1 hero-th-1-element-1 animate-bottom-to-top" data-animation-duration="1.5" data-animation-delay="0.5" style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)', opacity: 1 }} />
                        <img src="assets/images/hero-th-1-element-2.png" alt="hero-th-1-element-2" width={496} height={163} className="img-fluid hero-th-1 hero-th-1-element-2 animate-left-to-right" data-animation-duration="1.5" data-animation-delay={1} style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)', opacity: 1 }} />
                        <img src="assets/images/hero-th-1-element-3.png" alt="hero-th-1-element-3" width={238} height={235} className="img-fluid hero-th-1 hero-th-1-element-3 animate-right-to-left" data-animation-duration="1.5" data-animation-delay="1.5" style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(50px, 0px)', opacity: 0 }} />
                        <img src="assets/images/hero-th-1-element-4.png" alt="hero-th-1-element-4" width={499} height={838} className="img-fluid hero-th-1 hero-th-1-element-4" />
                        
                    </div>
                </section> */}

                <section className="section-hero">
                    <div className="hero-area hero-area-2">
                        <div className="hero-slider-1 swiper">
                            <div className="swiper-wrapper">
                                <SliderHomeBanner />
                            </div>
                        </div>
                    </div>
                </section>



                
            </div>


        </>
    )
}

export default HomeBanner